import { useQuery } from '@apollo/client';
import { GET_TOTAL_ZIPCODES_COUNT, TotalZipcodesCountResponse, TotalZipcodesCountVariables } from '../graphql/queries/getTotalZipcodesCount';

export const useTotalZipcodesCount = (warehouseId: number) => {
  const { data, loading, error, refetch } = useQuery<
    TotalZipcodesCountResponse,
    TotalZipcodesCountVariables
  >(GET_TOTAL_ZIPCODES_COUNT, {
    variables: { warehouseId },
    skip: !warehouseId,
  });

  return {
    totalCount: data?.getTotalZipcodesCountByWarehouseId || 0,
    loading,
    error,
    refetch,
  };
};
